import {CSSProperties} from 'react';

import {css} from 'styled-components';

import {TFont} from '../theme';

const font = (fontSize: CSSProperties['fontSize'], lineHeight: CSSProperties['lineHeight']) => css`
  font-size: ${fontSize};
  line-height: ${lineHeight};
`;

const f1 = font('10px', '14px');

const f2 = font('12px', '14px');

const f3 = font('14px', '20px');

const f4 = font('16px', '22px');

const f5 = font('18px', '24px');

const f6 = font('20px', '28px');

const f7 = font('22px', '30px');

const f8 = font('24px', '32px');

const f9 = font('26px', '32px');

const f10 = font('28px', '36px');

const f11 = font('30px', '38px');

const f12 = font('32px', '40px');

type TTruncateMultiRows = {
  line: number;
  fontSize: CSSProperties['fontSize'];
  lineHeight: CSSProperties['lineHeight'];
};

const truncateMultiRows = ({line, fontSize = '12px', lineHeight = 1.6}: TTruncateMultiRows) => css`
  display: block;
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  max-height: calc(${fontSize} * ${lineHeight} * ${line});
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${line};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const breakWord = css`
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const truncate = css`
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const fonts = {f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12};

const getFont = (key?: TFont) => (!!key ? fonts[key] : '');

export const typographyMixins = {
  ...fonts,
  getFont,
  truncateMultiRows,
  truncate,
  breakWord,
} as const;
